// extracted by mini-css-extract-plugin
module.exports = {"popup__heading":"styles_popup__heading__7k6PD"};